<script setup>

    import { defineModel, defineProps } from 'vue'
    import Info from '../../images/SVG/IconSet/Info.svg?raw'

    const model = defineModel()

    const props = defineProps({
        icon: String,
        name: String,
        info: String,
        value: String,
        checked: Boolean,
    })

    const classList = [
        'product-radio'
    ]

    if (props.icon) {
        classList.push('product-radio--vertical')
    }

</script>

<template>
    <label :class="classList">
        <input type="radio" :name="name" :value="value" :checked="checked"  v-model="model" />
        <div v-if="icon" v-html="icon"></div>
        <div class="product-radio__label">
            <div class="product-radio__dot">
                <span></span>
            </div>
            <span>{{ value }}</span>
            <div v-if="info" class="tooltip-trigger">
                <div class="tooltip">{{ info }}</div>
                <div v-html="Info"></div>
            </div>
        </div>
    </label>
</template>
